module.exports = __webpack_public_path__ + "static/img/application4-3.6790449.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application4-3.jpg
// module id = 3FW3
// module chunks = 0